

import React, { useState, useRef, useEffect } from 'react';
import { Box, TextField, Button, Typography, Paper, CircularProgress } from '@mui/material';
import axios from "../components/api";
import ReactMarkdown from 'react-markdown';

const ChatWindow = ({ sessionId, setSessions }) => {
    const [query, setQuery] = useState('');
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const scrollRef = useRef(null);

    const sendMessage = async () => {
        if (!query.trim() || loading) return;

        const newMessages = [...messages, { role: 'user', content: query }];
        setMessages([...newMessages, { role: 'assistant', content: 'Generating answer...' }]);
        setLoading(true);
        setQuery('');

        try {
            const response = await axios.post('/ask', { query });
            const { answer, session_id } = response.data;

            const updated = [...newMessages, { role: 'assistant', content: answer }];
            setMessages(updated);
            setSessions(prev => [...new Set([...prev, session_id])]);
        } catch (err) {
            setMessages(prev => [
                ...newMessages,
                { role: 'assistant', content: '**Error:** Could not connect to AI service.' }
            ]);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [messages]);

    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 2, height: '100%' }}>
            <Typography variant="h5" sx={{ fontWeight: "bold" }} gutterBottom> MAYI IQX</Typography>

            <Box
                ref={scrollRef}
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    mb: 2,
                    pr: 1,
                    maxHeight: 'calc(100vh - 200px)',
                }}
            >
                {messages.map((msg, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: msg.role === 'user' ? 'flex-start' : 'flex-end',
                            mb: 1,
                        }}
                    >
                        <Paper
                            elevation={3}
                            sx={{
                                padding: 2,
                                maxWidth: '100%',
                                overflowWrap: 'break-word',
                                wordBreak: 'break-word',
                                backgroundColor: msg.role === 'user' ? '#eeeeee' : '#1976d2',
                                color: msg.role === 'user' ? 'black' : 'white',
                                textAlign: 'left',
                            }}
                        >
                            <ReactMarkdown>{msg.content}</ReactMarkdown>
                        </Paper>
                    </Box>
                ))}
            </Box>

            <Box sx={{
                display: 'flex',
                gap: 1,
                position: 'sticky',
                bottom: 0,
                backgroundColor: '#282c34',
                paddingTop: 1,
                pt: 2
            }}>
                <TextField
                    fullWidth
                    value={query}
                    placeholder="Ask something..."
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                    disabled={loading}
                    InputProps={{
                        style: {
                            backgroundColor: 'white',
                            borderRadius: '4px'
                        }
                    }}
                />
                <Button
                    variant="contained"
                    onClick={sendMessage}
                    disabled={loading}
                    sx={{ minWidth: '100px' }}
                >
                    {loading ? <CircularProgress size={20} color="inherit" /> : 'Send'}
                </Button>
            </Box>
        </Box>
    );
};

export default ChatWindow;
